export var REQUEST_PASSWORD_RESET_EMAIL_MUTATION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "requestPasswordResetEmail"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "email"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "requestPasswordResetEmail"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "email"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "email"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "connection"
          },
          "arguments": [{
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "key"
            },
            "value": {
              "kind": "StringValue",
              "value": "requestPasswordResetEmail",
              "block": false
            }
          }]
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 172,
    "source": {
      "body": "\n    mutation requestPasswordResetEmail($email: String!) {\n        requestPasswordResetEmail(email: $email)\n            @connection(key: \"requestPasswordResetEmail\")\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export default {
  queries: {},
  mutations: {
    requestPasswordResetEmailMutation: REQUEST_PASSWORD_RESET_EMAIL_MUTATION
  }
};